<template>
  <div v-if="requirementsEmpty" class="mt-2">
    <p class="font-weight-medium">
      <span class="display-18 ">{{ title }}</span> <v-icon right primary--color class="icon-new mx-1 display-26-fixed " color="primary" />
    </p>
    <v-layout pa-0 class="display-18 pa-0" wrap>
      <span class="display-18 region-item">{{ salary }}</span>
    </v-layout>
  </div>
</template>

<script>
export default {

  props: {
    salary: {
      type: String,
      required: false,
      default: ''
    },
    requirementsEmpty: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      title: 'טווח שכר'

    }
  },

}
</script>

<style lang="scss" scoped>
p {
  display: list-item;
  list-style: none;
  position: relative;
}
.region-item + .region-item:before {
  content: ", ";
}

</style>
